
import React, { useRef } from 'react';
import { User, Language } from '../../types';

interface ProfileTabProps {
  user: User;
  language: Language;
  onUpdateUser: (userData: Partial<User>) => void;
}

const ProfileTab: React.FC<ProfileTabProps> = ({ user, language, onUpdateUser }) => {
  const isRtl = language === 'ar';
  const avatarInputRef = useRef<HTMLInputElement>(null);

  const handleAvatarChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onUpdateUser({ avatar: reader.result as string });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="animate-in fade-in slide-in-from-right-4 duration-300 space-y-6">
      <div className="flex flex-col items-center">
        <div className="relative group cursor-pointer" onClick={() => avatarInputRef.current?.click()}>
          <div className="w-20 h-20 rounded-2xl bg-slate-50 dark:bg-white/5 border border-slate-200 dark:border-white/10 overflow-hidden flex items-center justify-center text-emerald-500 text-2xl font-black shadow-lg">
            {user.avatar ? <img src={user.avatar} alt={user.name} className="w-full h-full object-cover" /> : user.name?.charAt(0)}
          </div>
          <div className="absolute inset-0 bg-black/40 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
            <i className="fas fa-camera text-sm"></i>
          </div>
          <input type="file" ref={avatarInputRef} onChange={handleAvatarChange} accept="image/*" className="hidden" />
        </div>
        <div className="mt-3 text-center">
           <h3 className="text-xs font-black text-slate-800 dark:text-white">{user.name}</h3>
           <p className="text-[10px] text-slate-400 font-medium">{user.email}</p>
        </div>
      </div>

      <div className="space-y-4 max-w-sm mx-auto">
        <div className="space-y-1.5">
          <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest px-1">{isRtl ? 'الاسم' : 'Display Name'}</label>
          <div className="relative">
            <i className={`fas fa-user absolute ${isRtl ? 'right-4' : 'left-4'} top-1/2 -translate-y-1/2 text-slate-300 text-[10px]`}></i>
            <input 
              type="text" 
              value={user.name}
              onChange={(e) => onUpdateUser({ name: e.target.value })}
              className={`w-full bg-slate-50 dark:bg-white/5 border border-slate-200 dark:border-white/5 rounded-xl ${isRtl ? 'pr-10 pl-4' : 'pl-10 pr-4'} py-2.5 text-xs font-bold text-slate-700 dark:text-white focus:border-emerald-500/50 focus:ring-1 focus:ring-emerald-500/50 outline-none transition-all`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProfileTab;
